<template>
    <modal id="send-email-modal">
        <div class="modal-container with-table" slot="modal-container">
            <div class="close" v-on:click="$emit('close')">
                <SvgIcon icon="close"/>
            </div>

            <h2>{{ $t('modal.send-email.headline') }}</h2>

            <p class="bold">{{ $t('modal.send-email.text') }}</p>

            <div class="modal-table">
                <p class="label-name">{{ $t('modal.send-email.tenant.label') }}</p>
                <div class="item" v-for="tenant in customContract.tenants">
                    <div class="name">
                        <span class="icon">
                            <SvgIcon icon="avatar"/>
                        </span>
                        <p v-if="tenant.full_name">{{ tenant.full_name }}</p>
                        <p v-else>{{ $t('modal.send-email.tenant.no-name') }}</p>
                    </div>
                    <div class="email">
                        <p>{{ tenant.email }}</p>
                    </div>
                </div>

                <p class="label-name">{{ $t('tenant-contracts.landlord.label') }}</p>
                <div class="item">
                    <div class="name">
                        <span class="icon">
                            <SvgIcon icon="avatar"/>
                        </span>
                        <p v-if="customContract.landlord">{{ customContract.landlord.name }}</p>
                        <p v-else>{{ $t('modal.send-email.tenant.no-name') }}</p>
                    </div>
                    <div class="email">
                        <p>{{ customContract.landlord_email }}</p>
                    </div>
                </div>
            </div>

            <div>
                <label class="custom-checkbox">
                    <input type="checkbox" v-model="termsAccepted">
                    <span class="checkbox">
                        <SvgIcon icon="checkmark-input"/>
                    </span>
                    <div class="text">
                        <p>{{ $t('register.accept-terms.text') }}<a target="_blank" href="https://www.rently.dk/terms/">{{ $t('register.accept-terms.link') }}</a></p>
                    </div>
                </label>
                <p class="comment">
                    {{ $t('modal.send-email.comment-text') }}
                </p>
            </div>

            <button class="purple" :disabled="!termsAccepted || state === 'saving'" @click="$emit('success')">
                <span v-if="state === 'saving'">Sending...</span>
                <span v-else>{{ $t('digital.tabs.review.send-email') }}</span>
            </button>

        </div>
    </modal>
</template>

<script>
import SvgIcon from "../../../components/Svg";


export default {
    name: "CustomContractSendConfirmation",
    props: ['customContract', 'state'],
    components: {
        SvgIcon
    },
    data: function() {
        return {
            termsAccepted: false,
        }
    }
}
</script>

<style scoped>

</style>
